module.exports = __webpack_public_path__ + "50030775291f4b75c81ba2860575028f.jpg";